(function ($) {

    $(function () {
        if ($('.product-card').length < 1) {
            return;
        }

        $('body').align({
            selector: '.product-card .product-card__content .title, .product-card .product-card__content p, .product-card .links .links__link .site-button'
        });
    });

})(jQuery);